import { AbstractControl } from '@angular/forms';

export function AgeValidator(
  control: AbstractControl
): { [key: string]: boolean } | null {

  let value = control.value;
 
  let today = new Date();
  let birthday = new Date(value);

  let age = today.getFullYear() - birthday.getFullYear();
  let m = today.getMonth() - birthday.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
    age--;
  }


  if (age < 18) {
    return { underAge : true };
  }


  return null;
}